import { NgModule } from '@angular/core';
import { ShaveDirective } from './shave.directive';

import { DecodePipe, DollarFormatPipe, EllipsizePipe, TimeSlotIdFormatPipe, TscCurrencyFormatPipe, SafePipe, ItemNoPipe  } from './customPipe';


export class UtilityModule { 
}


// WEBPACK FOOTER //
// C:/AzureDevOpsAgent/_work/3/s/TSC.Web.WebFactory/node_modules/ngc-webpack??ref--0-1!C:/AzureDevOpsAgent/_work/3/s/TSC.Web.WebFactory/node_modules/angular2-template-loader!../utility/utility.module.ts